// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.boleto-info {\n  color: #72737A;\n  font-weight: 700;\n  font-size: 12px;\n}\n.subtitle {\n  color: var(--brand--le--secondary-color--base);\n  font-weight: 400;\n  font-size: 12px;\n}\n.discount-info {\n  color: #72737A;\n  padding-top: 4px;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
